import React, { useState, useEffect, useRef, useReducer } from "react";
import { useEventContext } from "../../../context/EventContext";
import { useStreamContext } from "../../../context/StreamContext";
import { useLocaleContext } from "../../../context/LocaleContext";
import { useQuestionsContext } from "../../../context/QuestionsContext";
import { useModalContext } from "../../../context/ModalContext";
import { useUserContext } from "../../../context/UserContext";
import InputField from "../../Authentication/InputField";
import UIButton from "../../../../../globalComponents/UIComponents/UIButton";
import getFullname from "../../../helpers/get-fullname";
import { usePlayerContext } from "../../../context/PlayerContext";
import OptionEpisode from "../../Authentication/InputField/SelectOptions/OptionEpisode";
import UserAuthenticationModal from "../../User/UserAuthenticationModal";
import { setFocusToEnd } from "../../../helpers/set-focus-to-end";
import EmojiPicker from "../../CommentMessages/EmojiPicker";
import { MESSAGE_EMOJI_SRC } from "../../../constants/components/emoji";
import { encodeInnerHTML } from "../../../helpers/html-helpers";
import { CButton } from "../../UI";
import "./style.scss";

export default ({ onSubmit, onClose, maxMessageLength = 2048, episode, member, selectStream = undefined }) => {
    const { event } = useEventContext();
    const { moduleAuth, moduleQuestion, moduleEpisode, chatMessageThemes } = event || {};
    const { streams, stream } = useStreamContext();
    const { currentEpisode, tabletView } = usePlayerContext();
    const { user } = useUserContext();
    const { renderModal } = useModalContext();
    const $locale = useLocaleContext();
    const [targetStream, setTargetStream] = useState(selectStream !== undefined ? selectStream : (stream ? stream : null));
    const [targetEpisode, setTargetEpisode] = useState(episode || currentEpisode || null);
    const [targetMember, setTargetMember] = useState(member || null);
    const { anonymousEnabled, question, changeQuestion } = useQuestionsContext();
    const [text, setText] = useState(question || '');
    const [themeId, setThemeId] = useState();
    const [error, setError] = useState({});
    const [anonymous, setAnonymous] = useState(false);
    const [isFocused, setFocused] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const className = 'question-message-write';

    const [isEmojiPickerOpen, setEmojiPickerOpen] = useState(false);
    const [contentPickerMeta, updateContentPickerMeta] = useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            top: 0,
            bottom: 0,
            width: 0,
            height: 0,
        },
    );

    const formRef = useRef(null);
    const textInputRef = useRef(null);
    const emojiPickerTriggerRef = useRef(null);
    const emojiPickerRef = useRef(null);
    const containerRef = useRef(null);

    const handleChangeText = ({ isChar = true }) => {
        if (isChar) {
            setEmojiPickerOpen(false);
        }

        const encodedInnerHtml = encodeInnerHTML(textInputRef.current.childNodes);
        setText(encodedInnerHtml);
        changeQuestion(encodedInnerHtml);
    }

    let episodes = [];
    if (targetStream) {
        episodes = streams?.find(s => s.streamKey === targetStream.streamKey).episode;
    } else {
        episodes = streams?.reduce((episodes, stream) => episodes.concat(stream.episode), []);
    }

    let tragetStreams = streams;
    if (member) {
        tragetStreams = streams?.filter(stream =>
            stream.episode?.findIndex(episode =>
                episode.groups?.findIndex(group =>
                    group.members?.findIndex((memberItem) =>
                        memberItem.member.id === member.id) !== -1) !== -1) !== -1);

        episodes = episodes.filter(episode =>
            episode.groups?.findIndex(group =>
                group.members?.findIndex((memberItem) =>
                    memberItem.member.id === member.id) !== -1) !== -1);
    }

    useEffect(() => {
        if (tragetStreams.length === 1) {
            setTargetStream(tragetStreams[0]);
        }
        if (textInputRef.current) {
            textInputRef.current.textContent = text;
        }
    }, []);

    const targetEpisodes = targetEpisode ? [targetEpisode] : episodes;
    const targetMembers = targetEpisodes.reduce((members, episode) => {
        return members
            .filter(({ hide }) => !hide)
            .concat(episode.groups.reduce((members, group) => members.concat(group.members.map(({ member }) => member)), []));
    }, []).filter((member, index, all) => all.findIndex(({ id }) => id === member.id) === index && member.allowQuestions);

    const handleChangeTargetStream = (id) => {
        id = parseInt(id) || null;
        setTargetStream(streams.find((stream) => stream.id === id));
        if (!episode) {
            setTargetEpisode(null);
        }
        if (!member) {
            setTargetMember(null);
        }
    }
    const handleChangeTargetEpisode = (id) => {
        id = parseInt(id) || null;
        if (id > 0) {
            setTargetEpisode(episodes.find((episode) => episode.id === id));

        } else {
            setTargetEpisode(null);
        }
    }
    const handleChangeTargetMember = (id) => {
        id = parseInt(id) || null;
        if (id > 0) {
            setTargetMember(targetMembers.find((member) => member.id === id));
        } else {
            setTargetMember(null);
        }
    }

    const handleTextInputKeyUp = (e) => {
        if (e.code === 'Escape') {
            return onClose ? onClose() : handleReset();
        }
        if (e.code === 'Enter' && (e.ctrlKey || e.altKey)) {
            return handleSubmit();
        }
    }

    const handleSubmit = async (e) => {
        e?.preventDefault();

        if (!text || isSending) {
            return;
        }

        if (isThemesEnabled && !themeId) {
            setError(prev => ({ ...prev, theme: true }));
            return;
        }

        const isAuth = await new Promise((resolve) => {
            const { require, anonymous: authAnonymous } = moduleAuth || {};
            const { allowAnonymousMessage } = moduleQuestion || {};
            const skipAuthEnabled = !require && authAnonymous && allowAnonymousMessage;
            const needAuth = skipAuthEnabled ? !anonymous : !user;

            if (needAuth) {
                renderModal(
                    UserAuthenticationModal,
                    { event, $locale, onClose: (props) => resolve(props?.isAuth) },
                    null,
                    true,
                );
            } else {
                resolve(true);
            }
        });

        if (!isAuth) {
            return;
        }

        setIsSending(true);
        try {
            await onSubmit({
                text,
                streamKey: targetStream?.streamKey || null,
                episodeId: targetEpisode?.id || null,
                themeId: themeId || null,
                targetMemberId: targetMember?.id || null,
                anonymous,
            });
            handleReset();
        } catch (e) { }
        setIsSending(false);

    }

    const handleReset = () => {
        setText('');
        setAnonymous(false)
        setTargetEpisode(null);
        setTargetMember(null);
        changeQuestion('');
    };

    const handleBeforeInput = (e) => {
        if (text.length >= maxMessageLength) {
            e.preventDefault();
        }
    }

    const handlePasteText = (e) => {
        const combinedText = text + e.clipboardData?.getData('text/plain') || '';

        if (combinedText.length > maxMessageLength) {
            const slicedText = combinedText.slice(0, maxMessageLength)
            textInputRef.current.textContent = slicedText
            textInputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
            setText(slicedText)
            setFocusToEnd(textInputRef)
        }
    }

    const handleOpenEmojiPicker = (e) => {
        if (text.length < maxMessageLength) {
            updateEmojiPickerStyles();
            setEmojiPickerOpen(!isEmojiPickerOpen);
        }
    };

    const handleSelectEmoji = (emoji) => {
        textInputRef.current.focus();

        if (text.length >= maxMessageLength) return;

        const image = document.createElement('img');
        image.setAttribute('src', MESSAGE_EMOJI_SRC(emoji.codes.join('_')));
        textInputRef.current.appendChild(image);

        setFocusToEnd(textInputRef);
        handleChangeText({ isChar: false });
    };

    const handleCloseEmojiPicker = (e) => {
        if (!isEmojiPickerOpen || !emojiPickerTriggerRef.current) {
            return;
        }

        if (!(e.target === emojiPickerTriggerRef.current || emojiPickerTriggerRef.current.contains(e.target))) {
            setEmojiPickerOpen(false);
        }
    };

    const updateEmojiPickerStyles = () => {

        if (!emojiPickerRef.current || !containerRef.current) {
            return;
        }

        const containerContentRect = containerRef.current.getBoundingClientRect();
        const formBlockRect = formRef.current.getBoundingClientRect();

        const emijiPickerHeight = window.innerWidth <= 880 ? (containerContentRect.height - (formBlockRect.height + 14)) : 252;

        updateContentPickerMeta({
            right: 0,
            width: 'calc(100% - 4px)',
            height: `${emijiPickerHeight}px`,
        });
    };

    const isShowSelectStream = (!stream || selectStream === null) && tragetStreams.length > 1;
    const isShowSelectEpisode = moduleEpisode.enabled && moduleQuestion.allowEpisodeMessage && !episode;
    const isShowSelectMember = moduleEpisode.membersEnabled && moduleQuestion.allowTargetMessage && !member;
    const isThemesEnabled = moduleQuestion.themesEnabled && !!chatMessageThemes?.length;

    return (
        <div className={`${className} ${isFocused ? `${className}-focused` : ''}`}>
            <form onSubmit={handleSubmit} ref={formRef}>
                {isShowSelectStream && (
                    <div>
                        <InputField
                            type={'select'}
                            name={'stream'}
                            value={targetStream?.id || ''}
                            onChange={handleChangeTargetStream}
                            options={tragetStreams.map((stream) => ({ value: stream.id, label: $locale.getProperty(stream, 'description') }))}
                            defaultOptionTitle={$locale.get('questions.writeForm.hallSelect.choice')}
                            label={$locale.get('questions.writeForm.hallSelect.title')}
                        />
                    </div>
                )}
                {isShowSelectEpisode && (<div>
                    <InputField
                        $locale={$locale}
                        placeholder={$locale.get('label.search')}
                        type={'select-search'}
                        name={'targetEpisode'}
                        noOptionsMessage={$locale.get('input.select.noOptions')}
                        value={targetEpisode ? { value: targetEpisode.id, label: $locale.getProperty(targetEpisode, 'name') } : { value: null, label: $locale.get('questions.writeForm.episodeSelect.choice') }}
                        onChange={handleChangeTargetEpisode}
                        options={episodes.map((episode) => ({ ...episode, value: episode.key, label: $locale.getProperty(episode, 'name') }))}
                        defaultOptionTitle={$locale.get('questions.writeForm.episodeSelect.choice')}
                        label={$locale.get('questions.writeForm.episodeSelect.title')}
                        OptionComponent={OptionEpisode}
                        optionCancel={{ label: $locale.get('questions.writeForm.episodeSelect.choice'), value: null }}
                    />
                </div>)}
                {isShowSelectMember && (<div>
                    <InputField
                        $locale={$locale}
                        placeholder={$locale.get('label.search')}
                        type={'select-search'}
                        name={'targetMember'}
                        noOptionsMessage={$locale.get('input.select.noOptions')}
                        value={targetMember ? { value: targetMember.id, label: getFullname(targetMember, $locale) } : { value: null, label: $locale.get('questions.writeForm.memberSelect.choice') }}
                        onChange={handleChangeTargetMember}
                        options={targetMembers.map((member) => ({ ...member, label: getFullname(member, $locale), value: member.id }))}
                        defaultOptionTitle={$locale.get('questions.writeForm.memberSelect.choice')}
                        label={$locale.get('questions.writeForm.memberSelect.title')}
                        optionCancel={{ label: $locale.get('questions.writeForm.memberSelect.choice'), value: null }}
                    />
                </div>)}
                {isThemesEnabled &&
                    <div>
                        <InputField
                            required
                            label={$locale.get('questions.writeForm.themeSelect.title')}
                            type={'select'}
                            name={'theme'}
                            error={!!error.theme}
                            value={themeId || ''}
                            onChange={(themeId) => { setError(prev => ({ ...prev, theme: false })); setThemeId(themeId) }}
                            options={chatMessageThemes.map((theme) => ({ value: theme.id, label: $locale.getProperty(theme, 'title') }))}
                        />
                    </div>
                }
                <div ref={containerRef} style={{ position: 'relative' }}>
                    <label htmlFor={'text'} className={`${className}-label`}>{$locale.get('questions.writeForm.placeholder')}</label>
                    <div className={`${className}-border`} id="input-question">
                        <div>
                            <div className={`${className}-wrapper`}>
                                <div
                                    ref={textInputRef}
                                    role="textarea"
                                    className={`scrollable ${className}-textarea`}
                                    style={{ width: '100%' }}
                                    contentEditable={typeof InstallTrigger !== 'undefined' || "plaintext-only"}
                                    suppressContentEditableWarning
                                    onBeforeInput={handleBeforeInput}
                                    onPaste={handlePasteText}
                                    onInput={handleChangeText}
                                    onKeyUp={handleTextInputKeyUp}
                                    onFocus={() => setFocused(true)}
                                    onBlur={() => setFocused(false)}
                                    onTouchStart={() => setFocused(true)}
                                    onTouchMove={() => setFocused(false)}
                                />
                            </div>
                            <div className={`${className}-controls`}>
                                {!tabletView &&
                                    <div ref={emojiPickerTriggerRef} style={{ height: 16 }}>
                                        <CButton
                                            icon="emoji_list"
                                            blank
                                            size="xs"
                                            className={`${className}-emoji-button`}
                                            onClick={handleOpenEmojiPicker}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {!tabletView &&
                        <div
                            ref={emojiPickerRef}
                            style={{ ...contentPickerMeta }}
                            className={`${className}-emoji-picker ${isEmojiPickerOpen ? `${className}-emoji-picker--opened` : ''}`}
                        >
                            <EmojiPicker
                                isOpened={isEmojiPickerOpen}
                                onSelect={handleSelectEmoji}
                                onClose={handleCloseEmojiPicker}
                            />
                        </div>
                    }

                    <div className={`${className}-footer`}>
                        <span className="max-message-length">{$locale.get('messages.writeForm.maxMessageLength', { current: text.length, max: maxMessageLength })}</span>
                        {/* <a onClick={handleReset}>{$locale.get('questions.writeForm.reset')}</a> */}
                    </div>
                </div>
                {anonymousEnabled && <div className={'ui-input-component'}>
                    <label>
                        <input
                            type={'checkbox'}
                            name={'anonymous'}
                            checked={anonymous}
                            onChange={(e) => setAnonymous(e.target.checked)}
                        />
                        {$locale.get('questions.writeForm.anonymous')}
                    </label>
                </div>}
                <div>
                    <UIButton type={'submit'} style={'primary'} disabled={!text || isSending}>
                        {$locale.get('questions.writeForm.submit')}
                    </UIButton>
                </div>
            </form>
        </div>
    );
}
